import React, { useContext, useEffect, useState, lazy, Suspense } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../AuthContext/Authcontext";
import LoadingSpinner from "./LoadingSpinner ";

const Login = lazy(() => import("../LoginPages/Login"));
const Dashboard = lazy(() => import("../Component/Dashboard"));
const ProtectedRoute = lazy(() => import("../../ProtectedRoute/ProtectedRoute"));
const Layout = lazy(() => import("../Layout/Layout"));

const Profile = lazy(() => import("../Setting/Profile"));
const ChangePassword = lazy(() => import("../Setting/ChangePassword"));
const ChangeEmail = lazy(() => import("../Setting/ChangeEmail"));
const SiteDetails = lazy(() => import("../ManageSite/SiteDetails"));
const UserEntry = lazy(() => import("../ManageUser/UserEntry"));
const SiteProject = lazy(() => import("../ManageSite/SiteProject"));
const SuperAdminProject = lazy(() => import("../ManageSite/SuperAdmin/SuperAdminProject"));
const SuperSiteEntry = lazy(() => import("../ManageSite/SuperAdmin/SuperSiteEntry"));
const SuperUserEntry = lazy(() => import("../ManageUser/SuperAdmin/SuperUserEntry"));
const TyreExcelImport = lazy(() => import("../MasterPages/TyreExcelImport/TyreExcelImport"));
const TransportReport = lazy(() => import("../Report/TransportReport"));
const Vehicles = lazy(() => import("../Component/Vehicles"));
const Drivers = lazy(() => import("../Component/Drivers"));
const Trips = lazy(() => import("../Component/Trips"));

const DownloadingIdS = lazy(() => import("../MasterPages/ButtonIDS/DownloadingIdS"));
const ResetForm = lazy(() => import("../LoginPages/ResertForm"));


const MainRoute = () => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);
  const location = useLocation();
  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    if (initialLoad) {
      setInitialLoad(false);
    }
  }, [initialLoad]);

  if (isLoading || initialLoad) {
    return <LoadingSpinner />;
  }

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes location={location} key={location.pathname}>
        {/* Public Routes */}
        <Route path="reset-password" element={<ResetForm />} />
        <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />} />

        {/* Root redirect */}
        <Route
          path="/"
          element={
            isAuthenticated ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />
          }
        />
        {/* Protected Routes wrapped inside Layout */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          {/* <Route path="codegenerator" element={<CodeGenerator />} /> */}
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="downloadingids" element={<DownloadingIdS />} />

          <Route path="profile" element={<Profile />} />
          <Route path="changepassword" element={<ChangePassword />} />
          <Route path="changeemail" element={<ChangeEmail />} />
          <Route path="sitedetails" element={<SiteDetails />} />
          <Route path="userentry" element={<UserEntry />} />
          <Route path="siteproject" element={<SiteProject />} />
          <Route path="superadminsiteproject" element={<SuperAdminProject />} />
          <Route path="supersiteentry" element={<SuperSiteEntry />} />
          <Route path="superuserentry" element={<SuperUserEntry />} />

          <Route path="/superexcelimport" element={<TyreExcelImport />} />

          <Route path="transportreport" element={<TransportReport />} />
          <Route path="drivers" element={<Drivers />} />
          <Route path="vehicles" element={<Vehicles />} />
          <Route path="trips" element={<Trips />} />
                   
        </Route>
      </Routes>
    </Suspense>
  );
};

export default MainRoute;
